import * as companyApi from '../../api/company'
import * as fundMapApi from '../../api/fundMap'

// ACTIONS
function nextStepAction({ commit }) {
  commit('nextStep')
}
function prevStepAction({ commit }) {
  commit('previousStep')
}
function resetStepsAction({ commit }) {
  commit('resetSteps')
}
function resetFundMapStoreAction({ commit }) {
  commit('resetFundMapStore')
}
function setCompanyAttributeAction({ commit }, attributeObj) {
  commit('setCompanyAttribute', attributeObj)
}
function setFundMapCompanyAction({ commit }, company) {
  commit('setFundMapCompany', company)
}
function nullifyCompanyAttributeAction({ commit }, attributeKey) {
  commit('nullifyCompanyAttribute', attributeKey)
}
function nullifyCompanyAttributeObjectAction({ commit }) {
  commit('nullifyCompanyAttributeObject')
}
function nullifyFundMapCategoryAction({ commit }) {
  commit('nullifyFundMapCategory')
}
function selectFundMapCategoryAction({ commit }, payload) {
  commit('selectFundMapCategory', payload)
}
function setSearchObjectAction({ commit }, id) {
  commit('setSearchObject', id)
}

function toggleTriggerNextButtonAction({ commit }) {
  commit('toggleTriggerNextButton')
}

async function getFundMapCompanyAction({ dispatch, commit }, getParams) {
  try {
    commit('setFundMapCompanyLoading', true)
    const company = await companyApi.getCompany(getParams)
    commit('setFundMapCompany', company)

    commit('setUserRateLimited', false)
    commit('setFundMapCompanyLoading', false)
  } catch (err) {
    if (err.response.status == 429) {
      dispatch('notify', {
        newNotification: {
          type: 'warning',
          message: 'Sajnos túllépte a napi keresési limitet. Kérjük próbálja meg később újból.'
        }
      })
      commit('setUserRateLimited', true)
    }
    commit('setFundMapCompanyLoading', false)
  }
}

async function getFundMapCompetitionsAction({ commit }, getParams) {
  const { matchingCompetitions } = await fundMapApi.getCompetitions(getParams)
  commit('setFundMapCompetitions', matchingCompetitions)
}

// INITIAL STATE DECLARATION

const initialState = () => ({
  currentStep: 1,
  fundMapCompany: null,
  fundMapCompanyLoading: false,
  fundMapCompetitions: [],
  companyAttributes: {},
  selectedFundMapCategory: null,
  searchObjectId: '',
  triggerNextButton: false
  // {mainCategory: {icon: string, title: string, _id: string, subCategories: subCategory[]}, subCategory: {title: string, _id: string}} | null
})

// MUTATIONS
function nextStep(state) {
  if (state.currentStep === 3) {
    return
  }
  state.currentStep++
}
function previousStep(state) {
  if (state.currentStep === 1) {
    return
  }

  state.currentStep--
}
function resetSteps(state) {
  state.currentStep = 1
}
function setFundMapCompany(state, selectedCompany) {
  state.fundMapCompany = selectedCompany
}
function setFundMapCompanyLoading(state, selectedCompanyLoading) {
  state.fundMapCompanyLoading = selectedCompanyLoading
}
function resetFundMapStore(state) {
  Object.assign(state, initialState())
}
function selectFundMapCategory(state, selectedCategory) {
  state.selectedFundMapCategory = selectedCategory
}
function nullifyFundMapCategory(state) {
  state.selectedFundMapCategory = null
}
function setFundMapCompetitions(state, matchingCompetitions) {
  state.fundMapCompetitions = matchingCompetitions
}
function setCompanyAttribute(state, attributeObj) {
  state.companyAttributes = { ...state.companyAttributes, ...attributeObj }
}
function nullifyCompanyAttribute(state, attributeKey) {
  if (state.companyAttributes[attributeKey]) {
    state.companyAttributes[attributeKey] = null
  }
}
function nullifyCompanyAttributeObject(state) {
  state.companyAttributes = null
}
function setSearchObject(state, searchObjectId) {
  state.searchObjectId = searchObjectId
}
function toggleTriggerNextButton(state) {
  state.triggerNextButton = !state.triggerNextButton
}

const fundMapStore = {
  state: initialState(),
  actions: {
    nextStepAction,
    prevStepAction,
    resetStepsAction,
    getFundMapCompanyAction,
    setFundMapCompanyAction,
    resetFundMapStoreAction,
    selectFundMapCategoryAction,
    getFundMapCompetitionsAction,
    setCompanyAttributeAction,
    nullifyCompanyAttributeAction,
    nullifyCompanyAttributeObjectAction,
    nullifyFundMapCategoryAction,
    setSearchObjectAction,
    toggleTriggerNextButtonAction
  },
  getters: {
    currentStep: state => state.currentStep,
    fundMapCompany: state => state.fundMapCompany,
    fundMapCompanyLoading: state => state.fundMapCompanyLoading,
    fundMapCompetitions: state => state.fundMapCompetitions,
    searchObjectId: state => state.searchObjectId,
    selectedFundMapCategory: state => state.selectedFundMapCategory,
    fundMapCompanyAttributes: state => state.companyAttributes,
    triggerNextButton: state => state.triggerNextButton
  },
  mutations: {
    nextStep,
    previousStep,
    resetSteps,
    setFundMapCompany,
    setFundMapCompanyLoading,
    resetFundMapStore,
    selectFundMapCategory,
    setFundMapCompetitions,
    setCompanyAttribute,
    nullifyCompanyAttribute,
    nullifyCompanyAttributeObject,
    nullifyFundMapCategory,
    setSearchObject,
    toggleTriggerNextButton
  }
}

export default fundMapStore
